export function nextValue<T>(current: T, collection: readonly T[]): T {
  return collection[(collection.indexOf(current) + 1) % collection.length];
}
